import { all, fork } from 'redux-saga/effects';

import * as myFavoritesSagas from './myFavoritesSagas';

export default function* rootSaga() {
  yield all([...Object.values(myFavoritesSagas)].map(fork));
}
